// Maps a server VALIDATION error's zod issue paths onto form field names so
// the failing fields can be flagged inline. Wire messages are never rendered
// (packages/shared/src/errors.ts rule); callers pair each returned field name
// with their own translated copy.
import { ApiError } from '@wrapforce/shared';

export function invalidFieldsFromApiError(err: unknown): string[] {
  if (!(err instanceof ApiError) || err.code !== 'VALIDATION' || !err.issues) return [];
  return [...new Set(err.issues.map((issue) => String(issue.path[0] ?? '')).filter(Boolean))];
}
